export const MODE_BGN_ONLY = 0;
export const MODE_DUAL = 1;
export const MODE_EUR_ONLY = 2;

export function formattedPriceUtils(priceInput, exchangeRate, exchangeRateMode, convertMode, withSeparator = true) {
    const parsedRate = parseFloat(exchangeRate);
    const eurRate = Number.isFinite(parsedRate) && parsedRate > 0 ? parsedRate : 1.95583;

    const parsedMode = parseInt(exchangeRateMode, 10);
    const mode = Number.isFinite(parsedMode) ? parsedMode : MODE_DUAL;

    // Prices are stored in EUR; BGN is derived from the fixed rate.
    const rawPrice = parsePriceString(priceInput);
    const priceEUR = rawPrice;
    const priceBGN = rawPrice * eurRate;

    const formatHTML = (amount, currency) => {
        const isBGN = currency === 'лв.';
        const formatted = Number(amount).toFixed(2);
        const display = isBGN
            ? formatted.replace('.', ',') // BGN: comma
            : formatted;                 // EUR: dot

        return `${display}${currency}`;

    };

    let separator = withSeparator ? "/" : "";
    if (mode === MODE_BGN_ONLY) {
        return formatHTML(priceBGN, 'лв.');
    } else if (mode === MODE_DUAL) {
        return `${formatHTML(priceEUR, '€')}${separator}${formatHTML(priceBGN, 'лв.')}`;
    }
    return formatHTML(priceEUR, '€');
}

export function parsePriceString(priceString) {
    if (typeof priceString === 'number' ) return priceString;

    if (typeof priceString === 'string' )
        return Number(
            priceString
                .replace(/\s/g, '')       // remove spaces (including non-breaking)
                .replace('лв.', '')       // remove BGN currency
                .replace('€', '')         // remove Euro symbol
                .replace(',', '.')        // replace comma with dot for decimals
        ) || 0;
}